<template lang="pug">
  div
    Create(:location="location" :createDialog="createDialog" @close="createDialog = false" @getList="getListByStore()")
    Edit(:editDialog="editDialog" :editData="editData" @close="editDialog = false" @getList="getListByStore()")
    v-card
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title
          h1.subheading {{ $t('pageHeader.feedback') }}
        v-btn(color='teal', dark, small, absolute, bottom, right, fab @click="add") 
          v-icon add
      v-card-title
        v-flex(xs12 md4)
          v-text-field(v-model='search', append-icon='search', label='Search', single-line, hide-details clearable)
      v-data-table(:headers='headers' item-key="feedbackID" :items='feedback' :search="search" :loading='loading' :pagination.sync='pagination')
          template(slot='items' slot-scope='props')
            tr.pointer
              td.text-xs-left(@click="props.expanded = !props.expanded")
                v-icon.mr-2(small v-if="props.item.favorite" color="red") favorite
                v-icon.mr-2(small v-else) favorite_border
                | {{ $moment(props.item.createdAt).format('M/D/YY') }}
              td.text-xs-left(v-if="showLocation" @click="props.expanded = !props.expanded") {{ props.item.Store.CSPID }}
              td.text-xs-left(v-if="showLocation" @click="props.expanded = !props.expanded") {{ props.item.Store.businessName }}
              td.text-xs-left(@click="props.expanded = !props.expanded") {{ props.item.contactName }}
              td.text-xs-left(@click="props.expanded = !props.expanded") {{ props.item.phoneNumber }}
              td.text-xs-left(@click="props.expanded = !props.expanded") {{ props.item.User.fullName }}
              td.text-xs-left(@click="props.expanded = !props.expanded") {{ props.item.talkAbout }}
              
          template(slot='expand' slot-scope='props')
            v-card
              v-card-text
                v-layout(row wrap)
                  v-flex(xs12 sm6)
                    h3.font-weight-regular.mb-3
                      v-icon.mr-2(v-if="props.item.favorite" color="red") favorite
                      v-icon.mr-2(v-else) favorite_border
                      | Feedback
                    div {{ $t('labels.createdAt') }}
                    div.font-weight-medium {{ props.item.createdAt | moment('dddd, MMMM Do YYYY h:m a')  }}                    
                    div.mt-1 {{ $t('labels.talkAbout') }}
                    div.font-weight-medium {{ props.item.talkAbout }} 
                    div.mt-1 {{ $t('labels.createdBy') }}
                    div.font-weight-medium {{ props.item.User.fullName }}                    
                  v-flex(xs12 sm6)
                    h3.font-weight-regular.mb-3 Contact
                    div.mt-1 {{ $t('labels.name') }}
                    div.font-weight-medium {{ props.item.contactName }}
                    div.mt-1 {{ $t('labels.phoneNumber') }}
                    div.font-weight-medium {{ props.item.phoneNumber }}
                    div.mt-1 {{ $t('labels.rating') }}
                    div.font-weight-medium {{ props.item.rating }}
                  v-layout(row wrap)
                    v-spacer
                    v-btn(color="info" dark icon @click='edit(props.item)')
                      v-icon(small) edit 
                    v-btn(color="red" dark icon @click='deleteFeedback(props.item)')
                      v-icon(small) delete 
          v-alert(slot='no-results', :value='true', color='error', icon='warning')
            | Your search for "{{ search }}" found no results.
      

</template>

<script>
import feedbackService from "../service.js";
import Create from "./Create";
import Edit from "./Edit";
import { mapGetters } from "vuex";

export default {
  props: {
    location: {
      type: Object
    },
    showLocation: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      expand: false,
      editDialog: false,
      editData: {},
      createDialog: false,
      headers: [{
          text: this.$t("labels.createdAt"),
          value: "createdAt",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.contactName"),
          value: "contactName",
          sortable: true,
          width: "15%"
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "phoneNumber",
          sortable: true,
          width: "15%"
        },
        {
          text: this.$t("labels.createdBy"),
          value: "User.fullName",
          sortable: true,
          width: "15%"
        },
        {
          text: this.$t("labels.talkAbout"),
          value: "talkAbout",
          sortable: true
        }],
      search: null,
      feedback: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "feedbackID",
        descending: true
      }
    };
  },
  watch: {
    location() {
      this.getListByStore()
    }
  },
  components: {
    Create,
    Edit
  },
  created() {
    this.getListByStore();
  },
  methods: {
    deleteFeedback(data) {
      this.$swal({
        title: "Are you sure?",
        text: `You want to delete this feedback?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          return feedbackService
            .delete(data.feedbackID)
            .then(response => {
              if (response.data) {
                this.$swal("Deleted!", "Record has been deleted.", "success");
              }
              this.$Progress.finish();
              this.getList();
            })
            .catch(error => {
              this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
              }).fire({
                type: 'error',
                title: error.data.message
              })
              this.$Progress.fail();
            });
        }
      });
    },
    add() {
      this.createDialog = true;
    },
    edit(data) {
      this.editData = data;
      this.editDialog = true;
    },
    getList() {
      this.loading = true;
      return feedbackService.getAll().then(response => {
        this.feedback = response.feedback.data;
        this.loading = false;
        return response;
      });
    },
    getListByStore() {
      this.loading = true;
      // console.log('this.location', this.location)
      return feedbackService.getById(this.location.storeID).then(response => {
        // console.debug("feedback with store id", response);
        this.feedback = response;
        this.loading = false;
        return response;
      });
    }
  }
};
</script>

<style scoped>
</style>